import { render, staticRenderFns } from "./Administrasi.vue?vue&type=template&id=5ec34c1a&scoped=true&"
import script from "./Administrasi.vue?vue&type=script&lang=js&"
export * from "./Administrasi.vue?vue&type=script&lang=js&"
import style0 from "./Administrasi.vue?vue&type=style&index=0&id=5ec34c1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec34c1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCol,VContainer,VRow,VSimpleTable})
